<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="card-wrap"
            style="min-height: 400px"
          >
            <div slot="header">
              <span data-font="20">Load Inventory</span>
            </div>
            <b-row>
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    type="text"
                    :options="stockOptions"
                    label="label"
                    placeholder="Select Warehouse"
                    @input="changeStockpoint"
                  ></eb-select>
                </b-form-group>
              </b-col>
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    type="text"
                    :options="itemList"
                    label="label"
                    placeholder="Select Item"
                    @input="changeItem"
                  ></eb-select>
                </b-form-group>
              </b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input
                    type="text"
                    v-model="itemCount"
                    label="label"
                    placeholder="Quantity"
                    disabled
                  ></b-input>
                </b-form-group>
              </b-col>
              <b-col md="2" class="my-1">
                <b-button
                  variant="primary"
                  :disabled="!itemId || itemId === ''"
                  @click="downloadTemplate"
                  >Download Template
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <c-input
                    :inputType="'text'"
                    inputId="Quantity"
                    v-model="quantityValue"
                    lableText="Quantity"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3" class="my-1">
                <b-button
                  variant="primary"
                  :disabled="
                    !(
                      quantityValue &&
                      itemId &&
                      stockPointId &&
                      quantityValue !== '0'
                    )
                  "
                  @click="quickLoadInventory"
                  >Quick Load
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="10" class="my-1">
                <b-form-file
                  placeholder="Select a Template"
                  @change="selectFile"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
              </b-col>
              <b-col md="2" class="my-1">
                <b-button
                  variant="primary"
                  :disabled="!itemId || itemId === ''"
                  @click="uploadFile"
                  >Load Inventory
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";

export default {
  name: "LoadInventory",
  components: {
    ebSelect,
    cInput,
    loader,
  },
  data: () => {
    return {
      itemCount: "",
      itemId: "",
      providerId: "",
      stockPointId: "",
      selectedFile: null,
      quantityValue: "",
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      DownloadTemplate: "inventory/downloadInventoryTemplate",
      UploadFile: "inventory/uploadFileToStorage",
      LoadInventory: "inventory/loadInventory",
      LoadInventorySeed: "inventory/loadInventorySeed",
    }),
    changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        this.providerId = data.providerId;
        this.stockPointId = data._id;
        let payload = { needInventory: true };
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = data.providerId;
        }
        this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
      }
    },
    changeItem(data) {
      this.itemId = data._id;
      if(data.quantity){
        this.itemCount = data?.quantity[0]?.attributes?.Quantity || "";
      }
    },
    downloadTemplate() {
      this.loading = true;
      this.DownloadTemplate(this.itemId)
        .then((res) => {
          this.loading = false;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            window.URL.createObjectURL(new Blob([res]))
          );
          element.setAttribute("download", `${this.itemId}_template.xls`);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(() => (this.loading = false));
    },
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("file", this.selectedFile);
      formdata.append(
        "key",
        (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase()
      );
      formdata.append("isPublic", true);
      formdata.append("replaceExisting", true);
      formdata.append("basePath", "inventory");
      await this.UploadFile(formdata)
        .then((res) => {
          this.loadInventory(res.data.fileUrl);
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            text: "File Upload failed! please try again.",
          });
          this.loading = false;
        });
    },
    loadInventory(fileUrl) {
      let payload = {
        itemId: this.itemId,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        fileUrl: fileUrl,
      };
      this.LoadInventory(payload)
        .then((res) => {
          this.loading = false;
          this.$swal({
            type: "success",
            text: "Inventory Load Successfully!",
          });
        })
        .catch(() => (this.loading = false));
    },
    quickLoadInventory() {
      let payload = {
        itemId: this.itemId,
        stockPointId: this.stockPointId,
        quantity: Number(this.quantityValue),
      };
      this.LoadInventorySeed(payload)
        .then((res) => {
          this.loading = false;
          this.$swal({
            type: "success",
            text: "Inventory Loaded Successfully!",
          });
          this.quantityValue = null;
        })
        .catch(() => (this.loading = false));
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        let stockpoints = data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
        return stockpoints;
      } else {
        return [];
      }
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        let items = data.map((obj) => ({
          _id: obj._id,
          label: obj.description_summary,
          quantity: obj?.variations?.filter((volItem) => (
            volItem._id == obj.variationId
          )) || [],
        }));
        return items;
      } else {
        return [];
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant")
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important

.text-center
  text-align: center

.form-div label
  margin-top: 8px
</style>
